/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Bio_SeInputs */

const en_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Engineer crafting production-grade digital solutions with systematic precision and engineering rigor.`)
};

const ar_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهندس برمجيات يصنع حلولًا رقمية جاهزة للإنتاج بدقة منهجية وصرامة هندسية.`)
};

const bn_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সফটওয়্যার ইঞ্জিনিয়ার হিসেবে যত্ন নিয়ে প্রোডাকশন-রেডি ডিজিটাল সলিউশন তৈরি করি।`)
};

const de_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software-Ingenieur, der produktionstaugliche digitale Lösungen mit systematischer Präzision und technischer Strenge entwickelt.`)
};

const es_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingeniero de software que elabora soluciones digitales de nivel de producción con precisión sistemática y rigor de ingeniería.`)
};

const fr_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingénieur logiciel créant des solutions numériques de qualité production avec une précision systématique et une rigueur technique.`)
};

const pt_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engenheiro de software criando soluções digitais de nível de produção com precisão sistemática e rigor de engenharia.`)
};

const zh_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`软件工程师以系统精度和工程严谨性打造生产级数字解决方案。`)
};

const tr_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistematik hassasiyet ve mühendislik titizliğiyle üretim düzeyinde dijital çözümler üreten Yazılım Mühendisi.`)
};

const ru_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инженер-программист, создающий цифровые решения промышленного уровня с систематической точностью и инженерной строгостью.`)
};

const pl_resume_bio_se = /** @type {(inputs: Resume_Bio_SeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inżynier oprogramowania tworzący rozwiązania cyfrowe klasy produkcyjnej z systematyczną precyzją i rygorem inżynieryjnym.`)
};

/**
* | output |
* | --- |
* | "Software Engineer crafting production-grade digital solutions with systematic precision and engineering rigor." |
*
* @param {Resume_Bio_SeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_bio_se = /** @type {((inputs?: Resume_Bio_SeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Bio_SeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_bio_se(inputs)
	if (locale === "bn") return bn_resume_bio_se(inputs)
	if (locale === "de") return de_resume_bio_se(inputs)
	if (locale === "es") return es_resume_bio_se(inputs)
	if (locale === "fr") return fr_resume_bio_se(inputs)
	if (locale === "pt") return pt_resume_bio_se(inputs)
	if (locale === "zh") return zh_resume_bio_se(inputs)
	if (locale === "tr") return tr_resume_bio_se(inputs)
	if (locale === "ru") return ru_resume_bio_se(inputs)
	if (locale === "pl") return pl_resume_bio_se(inputs)
	return en_resume_bio_se(inputs)
});